import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    // The workspace header can grow on phones or when the trial banner wraps.
    // Keep the fixed drawer within the content area, above the sticky footer.
    const content = this.element.closest("#main-content")
    this.position = () => {
      if (content) {
        const bounds = content.getBoundingClientRect()
        this.panelTarget.style.top = `${Math.max(0, bounds.top)}px`
        this.panelTarget.style.bottom = `${Math.max(0, window.innerHeight - bounds.bottom)}px`
      }
    }
    if (content) {
      this.layoutObserver = new ResizeObserver(this.position)
      this.layoutObserver.observe(content)
    }
    this.position()
    this.sync = () => {
      const closed = this.panelTarget.classList.contains("translate-x-full")
      this.panelTarget.inert = closed
      this.panelTarget.setAttribute("aria-hidden", String(closed))
      if (!closed && !this.wasOpen) {
        this.trigger = document.activeElement
        this.focusOnLoad = true
      }
      if (closed && this.wasOpen && this.panelTarget.contains(document.activeElement)) this.trigger?.focus()
      this.wasOpen = !closed
    }
    this.observer = new MutationObserver(this.sync)
    this.observer.observe(this.panelTarget, { attributes: true, attributeFilter: ["class"] })
    this.sync()
  }

  loaded() {
    if (!this.wasOpen) return
    const requested = this.panelTarget.querySelector('[data-drawer-focus="true"]')
    if (requested) {
      requested.focus({ preventScroll: true })
      requested.scrollIntoView({ block: "center" })
    } else if (this.focusOnLoad && (document.activeElement === this.trigger || document.activeElement === document.body)) {
      this.panelTarget.querySelector("button[aria-label='Close']")?.focus({ preventScroll: true })
    }
    this.focusOnLoad = false
  }

  open() { this.panelTarget.classList.remove("translate-x-full") }
  close() { this.panelTarget.classList.add("translate-x-full") }
  disconnect() {
    this.observer?.disconnect()
    this.layoutObserver?.disconnect()
  }
}
